/**
 * Dokumenten-Upload / KI-Container-Extraktion (H6 + K1, EPIC K).
 *
 * NUR Typen + Konstanten — bewusst frei von Laufzeit-Abhängigkeiten (kein `xlsx`), damit das
 * Frontend diese DTOs via `import type` aus `@ctp/shared` nutzen kann, ohne den Parser/das
 * KI-SDK ins Browser-Bundle zu ziehen (analog ADR-032). Der eigentliche Excel-Parser und der
 * OpenRouter-Client leben im `api`-Paket.
 *
 * Siehe docs/PRD.md §6.6 (FR-P14/P15), docs/ARCHITECTURE.md §4/§7, ADR-005/009/027.
 */
// ── Upload-Leitplanken (von Frontend zur Vorprüfung & Backend autoritativ genutzt) ─────
/** Maximale Upload-Größe für Excel/CSV (10 MB; Storage-Hardlimit liegt bei 50 MB). */
export const EXCEL_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
/** Erlaubte Dateiendungen (Whitelist, SEC-W4). */
export const EXCEL_ACCEPTED_EXTENSIONS = ['.xlsx', '.xls', '.csv'];
/**
 * Erlaubte MIME-Typen (SEC-W4). `application/octet-stream` ist tolerant gelistet, weil einige
 * Browser/Betriebssysteme Excel/CSV generisch senden — die Endung wird dann zusätzlich geprüft.
 */
export const EXCEL_ACCEPTED_MIME_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel', // .xls
    'text/csv',
    'application/csv',
    'text/plain', // manche Quellen liefern CSV als text/plain
    'application/octet-stream',
];
//# sourceMappingURL=documents.js.map